export const load_off = function(){
    const element = [document.getElementById("loading"),document.getElementById("loading_icon"),document.getElementById("load_circle")];
    element.forEach((v)=>{
        v.style.display = "none";
    });
}